<td>
  <div class="icon-wrapper qaroni-text-background">
    <mat-icon>{{ plan()?.icon }}</mat-icon>
  </div>
</td>
<td>
  <div class="me-2 text-sm">
    <div class="font-bold">{{ plan()?.name }}</div>
    @if (hasPrice) {
      @if (isMonthly()) {
        <ng-container *ngTemplateOutlet="monthRange" />
      } @else {
        <span class="font-light">
          {{ yearPlan?.minRange }} <ng-container i18n>a</ng-container>
          {{ yearPlan?.maxRange }} <ng-container i18n>empleados</ng-container>
        </span>
      }
    } @else {
      <span class="font-light" i18n>Mayor a 250 empleados</span>
    }
  </div>
</td>
<td>
  <div class="flex flex-col items-start justify-center">
    @if (hasPrice) {
      <ng-container *ngTemplateOutlet="monthPrice" />
      <ng-container *ngTemplateOutlet="yearPrice" />
    } @else {
      <div class="text-lg font-bold">
        <a
          class="qaroni-link mb-1"
          tabindex="0"
          (click)="onWeWillContactYou()"
          (keypress)="onWeWillContactYou()"
          i18n>
          ¡Te contactaremos!
        </a>
      </div>
    }
  </div>
</td>

<ng-template #monthRange>
  <span class="font-light">
    {{ monthPlan?.minRange }} <ng-container i18n>a</ng-container>
    {{ monthPlan?.maxRange }} <ng-container i18n>empleados</ng-container>
  </span>
</ng-template>

<ng-template #monthPrice>
  <div class="flex items-center">
    <mat-icon
      class="qaroni-mat-icon-20 mr-1 cursor-pointer text-primary hover:text-primary-40"
      matTooltip="Por empleado"
      fontIcon="info" />

    <span class="text-price text-lg font-bold">
      {{ monthPlan?.unitAmount | currency: monthPlan?.currency }}/
    </span>
    <ng-container i18n>mes</ng-container>
  </div>
</ng-template>

<ng-template #yearPrice>
  <div class="block">
    <div class="flex items-center">
      <mat-icon
        class="qaroni-mat-icon-20 mr-1 cursor-pointer text-primary hover:text-primary-40"
        matTooltip="Por empleado"
        fontIcon="info" />
      <span class="text-price text-lg font-bold">
        {{ yearPlan?.unitAmount | currency: yearPlan?.currency }}/
      </span>
      <ng-container i18n>año</ng-container>
    </div>
    <div class="text-discount">
      <del>
        {{ monthPlan?.unitAmount * 12 | currency: monthPlan?.currency }}
      </del>
      Obtén un 10% de descuento
    </div>
  </div>
</ng-template>
